var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-task-order',{staticClass:"pt-task-order__withData",attrs:{"statisticData":_vm.statisticData}})
}
var staticRenderFns = []

export { render, staticRenderFns }